import { Workflow } from 'modules/workflows/types';
import { JourneyVisitorMetricsResponseAction } from '../../actions';

export const filterWorkflowData = (workflow: Workflow) => {
  // filter nodes and edges out of workflow since they are saved in nodesReducer
  const keysToRemove = ['nodes', 'edges'];
  const filteredWorkflow = Object.entries(workflow).reduce(
    (acc, [key, value]) => (keysToRemove.includes(key) ? acc : { ...acc, [key]: value }),
    {},
  );

  return filteredWorkflow;
};

export const getInvalidNodeIds = (nodeIds: string[] = [], currentNodes: string[] = []) => {
  return currentNodes?.reduce((acc: string[], node) => {
    return nodeIds?.includes(node) ? acc : [...acc, node];
  }, []);
};

interface CountsData {
  count: number;
}

export interface FetchVisitorCoundsResponseAction {
  type: string;
  payload: {
    countsData: CountsData[];
  };
}

export const getVisitorCountSum = (action: FetchVisitorCoundsResponseAction) => {
  const { countsData = [] } = action.payload;
  return countsData.reduce((acc, { count }) => acc + count, 0) ?? 0;
};

export const updateJourneyForVisitorMetrics = (
  workflow: Workflow | Record<string, never> = {},
  action: JourneyVisitorMetricsResponseAction,
) => {
  const { payload } = action;
  const { journeyVisitorMetrics } = payload;
  const { visitorsEntered, visitorsFinished, visitorsExitedByRules } = journeyVisitorMetrics || {};
  return { ...workflow, visitorsEntered, visitorsFinished, visitorsExitedByRules };
};
